import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface Props extends Omit<IconButtonProps, 'title'> {
  title: string;
  children: React.ReactNode;
}

/** IconButton wrapped with a Tooltip for accessibility. */
export default function IconButtonTooltip({ title, children, ...rest }: Props) {
  return (
    <Tooltip title={title}>
      <IconButton aria-label={title} {...rest}>
        {children}
      </IconButton>
    </Tooltip>
  );
}
